<template>
    <div class="max-w-[1145px] px-[15px] w-full mx-auto mt-[6.75em] mb-[4.2em]">
        <div
            class="relative overflow-x-auto rounded-[14px] mt-[-63px]"
            :class="{ 'border border-[#eeeff2]': showBorder === true }"
        >
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 rounded-[15px]">
                <caption class="border-b border-[#eeeff2] px-6 py-3 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white">
                    <div class="flex items-center justify-between">
                        <span class="block text-[25px] font-[CircularBold]">Market Trend</span>
                        <div class="max-w-[355px] w-full">
                            <div class="flex">
                                <div class="relative w-full">
                                    <input
                                        v-model="search"
                                        type="search"
                                        id="location-search"
                                        class="block px-2.5 py-2 w-full z-20 text-sm text-gray-900 border border-[#eeeff2] bg-white rounded-lg order-gray-300"
                                        placeholder="Search"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </caption>
                <thead class="text-xs text-gray-700 uppercase bg-white">
                <tr>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">Market</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">Currency</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">Last Price</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">Change</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">Volume</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">24 High</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-6 py-3">
                        <button class="flex items-center gap-2">
                            <span class="block text-[#2a395a] text-[14px]">24 Low</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr
                        class="bg-white text-[12px] text-[#170f34]"
                        v-for="market in currentPageMarkets()"
                        :key="market.id"
                    >
                        <td class="px-6 py-1">
                            <a :href="`/exchange/` + market.title">{{ market.title_formatted }}</a>
                        </td>
                        <td class="px-6 py-1 text-[#a4a6aa]">
                            {{ market.currency }}
                        </td>
                        <td class="px-6 py-1">
                            {{ parseFloat(market.last_price).toFixed(market.price_decimals) }}
                        </td>
                        <td class="px-6 py-1" :class="market.change_day === 0 ? 'text-green' : (market.change_day > 0 ? 'text-success' : 'text-danger')">
                            <span
                                class="block w-fit text-white text-[12px] font-[600] rounded-[5px] px-[.38em] py-[.17em]"
                                :class="market.change_day >= 0 ? 'bg-[#58bd7d]' : 'bg-[#cf3d3d]'"
                            >
                                {{ market.change_day }}%
                            </span>
                        </td>
                        <td class="px-6 py-1">
                            {{ parseFloat(market.quote_volume_day).toFixed(market.price_decimals) }}
                        </td>
                        <td class="px-6 py-1">
                            {{ parseFloat(market.high_day).toFixed(market.price_decimals) }}
                        </td>
                        <td class="px-6 py-1">
                            {{ parseFloat(market.low_day).toFixed(market.price_decimals) }}
                        </td>
                    </tr>
                </tbody>
                <tfoot class="bg-white border-t border-[#eeeff2]">
                <tr>
                    <td colspan="7" class="text-center py-[15px] rounded-bl-[15px] rounded-br-[15px]">
                        <div class="flex items-center justify-center gap-[5px] text-[#2a395a] text-[14px] font-[CircularBook]">
                            <button
                                v-if="currentPage > 0"
                                @click="goToPreviousPage()"
                                class="bg-[#f3f4f9] border border-transparent rounded-[5px] px-2.5 py-1 tracking-wide h-[34px] hover:border hover:border-[#366fed] hover:bg-[#e0e8fa] hover:text-[#366fed]"
                            >
                                Previous
                            </button>
                            <button
                                v-for="(page) in Array.from(Array(pages()).keys())"
                                class="bg-[#f3f4f9] border border-transparent rounded-[5px] px-2.5 py-1 tracking-wide h-[34px] min-w-[34px] hover:border hover:border-[#366fed] hover:bg-[#e0e8fa] hover:text-[#366fed]"
                                :class="currentPage === page ? '!border-[#366fed] bg-[#e0e8fa] text-[#366fed]' : ''"
                                @click="goToPage(page)"
                            >
                                {{page + 1}}
                            </button>
                            <button
                                v-if="currentPage < pages() - 1"
                                @click="goToNextPage()"
                                class="bg-[#f3f4f9] border border-transparent rounded-[5px] px-2.5 py-1 tracking-wide h-[34px] hover:border hover:border-[#366fed] hover:bg-[#e0e8fa] hover:text-[#366fed]"
                            >
                                Next
                            </button>
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script setup>
import {onMounted, ref, watch} from "vue";
import {backendSocket} from "../../sockets";
const markets = ref(window.markets);
const search = ref("");
const currentPage = ref(0);
const props = defineProps({
    showBorder: {
        type: Boolean,
        default: false,
    }
});

watch(search, () => {
    currentPage.value = 0;
});

const filteredMarkets = () => {
    return markets.value.filter((market) => market.title_formatted.includes(search.value.toUpperCase()))
}

const goToPage = (page) => {
    currentPage.value = page;
}

const currentPageMarkets = () => {
    return filteredMarkets().slice(12 * currentPage.value, 12 * (currentPage.value + 1));
}

const pages = () => {
    return Math.ceil(filteredMarkets().length / 12);
}

const goToNextPage = () => {
    currentPage.value = currentPage.value + 1;
}

const goToPreviousPage = () => {
    currentPage.value = currentPage.value - 1;
}


onMounted(() => {
    backendSocket.channel('market.public').listen('.market_data.updated', ({marketData}) => {
        const foundIndex = markets.value.findIndex((el, index) => el.id === marketData.id)

        const newMarkets = markets.value;
        newMarkets[foundIndex] = marketData

        markets.value = newMarkets;
    });
})
</script>
